export const FADE_ANIMATION = { tension: 400, friction: 30 };
